import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import { ConditionalContainer } from 'gatsby-theme-core/src/components/container';
import useMenuItems from '../../../hooks/use-menu-items';
import useActiveMenu from '../../../hooks/use-active-menu';
import Wrapper from './wrapper';
import NavItem from './nav-item';
import NavItemIcon from './nav-item-icon';
import NavLink from './nav-link';
import Children from './children';
import ChildrenInner from './children-inner';
import ChildItem from './child-item';
import ChildLink from './child-link';
import PreviewChildLink from './preview-child-link';
import PreviewChildItem from './preview-child-item';
import PreviewChildTitle from './preview-child-title';
import PreviewChildContent from './preview-child-content';
import PreviewChildImage from './preview-child-image';
import Button from './button';
import activeClassName from '../activeClassName';
import Column from './column';

const ListNav = ({
  className,
  navBreakpoint,
  pageId = null,
  mustHaveSubpages = false,
}) => {
  const { menus } = useMenuItems();
  const { items, title, position } = menus[0];
  const menuName = `${title} (${position})`;

  // you can provide a custom pageId to active a menu item
  // for example, a category pageId for detail pages
  const activeMenu = useActiveMenu({ pageId, mustHaveSubpages });
  return (
    <nav className={`${className} nav-list-nav`}>
      <Button
        $navBreakpoint={navBreakpoint}
      />
      <Wrapper $navBreakpoint={navBreakpoint}>
        {items.map(({
          id,
          page,
          subpages,
          externalpage,
          icon,
          column,
        }) => {
          if (page || externalpage) {
            return (
              <NavItem key={id} $hasColumn={Boolean(column)}>
                <NavLink
                  menuName={menuName}
                  activeClassName={activeClassName}
                  className={(page?.slug && page?.slug === activeMenu?.page?.slug) ? activeClassName : ''}
                  to={externalpage?.externalLink || page?.slug}
                  as={externalpage?.externalLink === '#' ? 'span' : null}
                >
                  {externalpage?.externalTitle || page?.title}
                  {icon && (
                    <Image image={icon} />
                  )}
                  {subpages && subpages.length > 0 && (
                    <NavItemIcon />
                  )}
                </NavLink>
                {subpages && subpages.length > 0 && (
                  <Children
                    $hasColumn={Boolean(column)}
                    $columnBackgroundColor={column?.background?.color}
                    $columnBackgroundCustomColor={column?.background?.customColor}
                  >
                    <ConditionalContainer useContainer={Boolean(column)}>
                      <Column column={column} />
                      <ChildrenInner $hasColumn={Boolean(column)}>
                        {subpages.map(({ preview, ...subpage }) => {
                          if (preview) {
                            const {
                              id: previewId,
                              title: previewTitle,
                              page: previewPage,
                              image: previewImage,
                              content: previewContent,
                            } = preview;
                            return (
                              <PreviewChildItem key={previewId}>
                                <PreviewChildLink
                                  menuName={menuName}
                                  partiallyActive
                                  to={previewPage.slug}
                                >
                                  <PreviewChildTitle>{previewTitle}</PreviewChildTitle>
                                  <PreviewChildImage image={previewImage} />
                                  <PreviewChildContent>{previewContent}</PreviewChildContent>
                                </PreviewChildLink>
                              </PreviewChildItem>
                            );
                          }
                          return (
                            <ChildItem key={subpage.id} $hasColumn={Boolean(column)}>
                              <ChildLink
                                $hasColumn={Boolean(column)}
                                menuName={menuName}
                                activeClassName={activeClassName}
                                to={subpage.slug || subpage.externalLink}
                              >
                                {subpage.title || subpage.externalTitle}
                              </ChildLink>
                            </ChildItem>
                          );
                        })}
                      </ChildrenInner>
                    </ConditionalContainer>
                  </Children>
                )}
              </NavItem>
            );
          }
          return null;
        })}
      </Wrapper>
    </nav>
  );
};

export default styled(ListNav)``;
